import { render, staticRenderFns } from "./_DoEducationEndPeriod.vue?vue&type=template&id=c96d6d8a&scoped=true"
import script from "./_DoEducationEndPeriod.vue?vue&type=script&lang=js"
export * from "./_DoEducationEndPeriod.vue?vue&type=script&lang=js"
import style0 from "./_DoEducationEndPeriod.vue?vue&type=style&index=0&id=c96d6d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d6d8a",
  null
  
)

export default component.exports